var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewIconOnlyPhotoFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.834 6.799a.74.74 0 1 0-1.15.936l3.861 4.742c.133.163.328.261.539.272h.036a.738.738 0 0 0 .526-.219l8.423-8.478a.741.741 0 0 0-1.052-1.044l-7.842 7.894-3.341-4.103zM17.5 8.507v6.423a2.572 2.572 0 0 1-2.57 2.57H3.07A2.573 2.573 0 0 1 .5 14.93V3.07A2.574 2.574 0 0 1 3.07.5h10.109v1.187H3.069c-.762 0-1.383.62-1.383 1.384v11.86c0 .762.62 1.383 1.384 1.383h11.86c.763 0 1.385-.62 1.385-1.384V8.507H17.5z"
  })));
}
export default SvgReviewIconOnlyPhotoFilter;